import { Progress } from "antd";
import { Link } from "react-router-dom";

type Props = {
  location: {
    id: string;
    name: string;
    appointments: number;
    percent: number;
    imgUrl?: string;
  };
};

const RowSalonListData = ({ location }: Props) => {
  return (
    <>
      <div className="w-full flex items-center gap-2  max-w-[100px] ">
        <img
          src={location?.imgUrl}
          alt="Salon Logo"
          className="w-10 h-10 rounded-full"
        />
        <Link
          to={`/admin/salon-management/${location?.id}`}
          className="text-[#020418] whitespace-nowrap text-sm font-semibold text-center"
        >
          {
            location?.name || "No Name" //! to be able to navigate to this location profile
          }
        </Link>
      </div>
      <span className="w-full text-[#9999A7] font-medium max-w-[100px] text-left">
        {location?.appointments}
      </span>
      <Progress
        className="max-w-[100px]"
        percent={location?.percent}
        showInfo={false}
        strokeColor={"#00086D"}
      />
    </>
  );
};

export default RowSalonListData;
